import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

interface CancelLessonPayload {
  lessonId: string;
  // Read by the payout eligibility reducer to update the amount still due to the teacher
  hours: number;
  paidToTeacher: number;
}

export const teacherCancelLesson = createAsyncThunk<void, CancelLessonPayload, { extra: Partial<Dependencies> }>(
  "lessons/teacherCancelLesson",
  async ({ lessonId }, { extra: { teacherRepository } }) => {
    await teacherRepository!.cancelLesson(lessonId);
  },
);

export const resetLessonCancellation = createAction("lessons/resetLessonCancellation");
